export const GET_STDAPPLINF_INDEX_DISP = 'GET_STDAPPLINF_INDEX_DISP'
export const GET_STDAPPLINF_COLUMNS = 'GET_STDAPPLINF_COLUMNS'
export const GET_STDAPPLINF_LABELS = 'GET_STDAPPLINF_LABELS'
export const GET_STDAPPLINF_INDEX = 'GET_STDAPPLINF_INDEX'
export const GET_STDAPPLINF_TAPPOINF = 'GET_STDAPPLINF_TAPPOINF'
export const SET_STDAPPLINF_INDEX_DISP = 'SET_STDAPPLINF_INDEX_DISP'
export const SET_STDAPPLINF_COLUMNS = 'SET_STDAPPLINF_COLUMNS'
export const SET_STDAPPLINF_LABELS = 'SET_STDAPPLINF_LABELS'
export const SET_STDAPPLINF_INDEX = 'SET_STDAPPLINF_INDEX'
export const SET_STDAPPLINF_TAPPOINF = 'SET_STDAPPLINF_TAPPOINF'
export const TOGGLE_STDAPPLINF_PAGE = 'TOGGLE_STDAPPLINF_PAGE'
export const RECEIVED_STDAPPLINF_COLUMNS_LABELS = 'RECEIVED_STDAPPLINF_COLUMNS_LABELS'
export const RECEIVED_STDAPPLINF_INDEX = 'RECEIVED_STDAPPLINF_INDEX'
export const RECEIVED_STDAPPLINF_TAPPOINF = 'RECEIVED_STDAPPLINF_TAPPOINF'



// WEBPACK FOOTER //
// ./src/store/modules/stdapplinf/mutation-types.js